// src/components/dashboard/tiles/FreeAgentNewsTile.js
import React, { useState, useEffect } from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { leaguesAPI } from '../../../services/apiService';
import PlayerLink from '../../PlayerLink';

const FreeAgentNewsTile = ({ leagueId, league }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await leaguesAPI.getFreeAgentNews(leagueId);
        setNews(result?.news || result || []);
      } catch (e) {
        setNews([]);
      } finally {
        setLoading(false);
      }
    };
    if (leagueId) load();
  }, [leagueId]);

  return (
    <div className={`${dynastyTheme.components.card.base} p-6`}>
      <h3 className={`text-lg font-bold ${dynastyTheme.classes.text.white} mb-4`}>
        Free Agent News
      </h3>
      {loading ? (
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin" />
          <span className={`text-sm ${dynastyTheme.classes.text.neutralLight}`}>Loading...</span>
        </div>
      ) : news.length === 0 ? (
        <p className={`text-sm ${dynastyTheme.classes.text.neutralLight}`}>No recent news for free agents.</p>
      ) : (
        <div className="space-y-3 max-h-80 overflow-y-auto">
          {news.slice(0, 10).map((item, i) => (
            <div key={i} className={`flex gap-3 border-b ${dynastyTheme.classes.border.neutral} pb-3 last:border-0`}>
              <div className="w-1 rounded-full flex-shrink-0 bg-green-500" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <PlayerLink mlbId={item.player_id || null} name={item.player} style={{ fontSize: '0.875rem', fontWeight: 600, color: '#ffffff' }} />
                  <span className="text-xs px-1.5 py-0.5 rounded bg-green-500/20 text-green-400 border border-green-500/30 font-medium">
                    FA
                  </span>
                </div>
                <p className="text-sm text-gray-300 leading-relaxed line-clamp-3">
                  {item.body || item.content}
                </p>
                <div className="text-sm text-gray-400 mt-1.5">
                  {item.date ? new Date(item.date).toLocaleDateString() : ''}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FreeAgentNewsTile;
